import React, { useEffect } from 'react';

const Modal = ({ open, title, onClose, children }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape' && onClose) onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        {onClose && <button className="modal-close" onClick={onClose}>×</button>}
        {title && <div className="modal-title">{title}</div>}
        {children}
      </div>
    </div>
  );
};

export default Modal;
